export function objectKeysOnlyStrings (object) {
    const result = {}

    for (const key in object) {
        if (typeof object[key] === 'string') {
            result[key] = object[key]
        }
    }

    return result
}
